import React from 'react';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import moment from 'moment';
import NumericLabel from 'react-pretty-numbers';
import { prettyNumberParamsDB } from '../../../constants';
import { AttachmentsRow } from '../../../shared_elements';

export default function ShopVisitHistory({item, viewDetail}){
  return(
    <TableRow hover tabIndex={-1} style={{cursor:"pointer"}} >
      <TableCell onClick={viewDetail}>{item.name ? item.name : '--' }</TableCell>
      <TableCell onClick={viewDetail}>{item.shop_visit_start_date ? moment(item.shop_visit_start_date).format('MMM DD, YYYY'): '--'}</TableCell>
      <TableCell onClick={viewDetail}>{item.shop_visit_date ? moment(item.shop_visit_date).format('MMM DD, YYYY'): '--'}</TableCell>
      <TableCell onClick={viewDetail}>{item.tsn? item.tsn : '--'}</TableCell>
      <TableCell onClick={viewDetail}>{item.csn ? item.csn :'--' }</TableCell>
      <TableCell onClick={viewDetail}>{item.removal_reason ? item.removal_reason: '--'}</TableCell>
      <TableCell onClick={viewDetail}  className="status">
        {
          item.status && item.status.value==0 ?
          <div className="status-btn draft">{item.status.label ? item.status.label : '--' }</div> : null
        }
        {
          item.status && item.status.value==1 ?
          <div className="status-btn submitted">{item.status.label ? item.status.label : '--' }</div> : null
        }
        {
          item.status && item.status.value==2 ?
          <div className="status-btn workshop-in-review">{item.status.label ? item.status.label : '--' }</div> : null
        }
        {
          item.status && item.status.value==3 ?
          <div className="status-btn approved">{item.status.label ? item.status.label : '--' }</div> : null
        }
        {
          item.status && item.status.value==4 ?
          <div className="status-btn rejected">{item.status.label ? item.status.label : '--' }</div> : null
        }
        {
          item.status && item.status.value==5 ?
          <div className="status-btn workshop-approved">{item.status.label ? item.status.label : '--' }</div> : null
        }
         {
          item.status && item.status.value==6 ?
          <div className="status-btn workshop-rejected">{item.status.label ? item.status.label : '--' }</div> : null
        }
         {
          item.status && item.status.value==7 ?
          <div className="status-btn in-review">{item.status.label ? item.status.label : '--' }</div> : null
        }
        <div className="workscope-label">{item.workscope_details ? item.workscope_details : ''}</div>
      </TableCell>
      <TableCell onClick={viewDetail}>{item.shop_visit_facility ? item.shop_visit_facility:'--'}</TableCell>
      <TableCell onClick={viewDetail} style={{ whiteSpace:'nowrap'}}>{item.cost ? <NumericLabel params={prettyNumberParamsDB}>{item.cost}</NumericLabel> : '--'}</TableCell>
      <TableCell >{item?.attachments?.length> 0 ?<AttachmentsRow attachmentsData={item?.attachments}/>:"--"}</TableCell> 
    </TableRow>
  )
}
